// extracted by mini-css-extract-plugin
export default {"content":"DL-z","lookName":"EL-z","shopTheLookContainer":"FL-z","productContainer":"GL-z","imageContainer":"HL-z","mainImage":"IL-z"};